import { call, put, takeLatest } from 'redux-saga/effects';
import request from '../../api/request';
import { DateTime } from 'luxon';

function* fetchInvestData(payload) {
  try {
    yield put({ type: 'SHOW_LOADING' });

    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/security/investData` +
      `?page=${payload.value.page}` +
      `&offset=${payload.value.offset}` +
      `${payload.value.search ? `&search=${encodeURIComponent(payload.value.search)}` : ''}` +
      `${payload.value.from ? `&from=${encodeURIComponent(payload.value.from)}` : ''}` +
      `${payload.value.to ? `&to=${encodeURIComponent(payload.value.to)}` : ''}` +
      `${payload.value.senderIds ? `&senderIds=${encodeURIComponent(payload.value.senderIds)}` : ''}` +
      `${payload.value.operatorIds ? `&operatorIds=${encodeURIComponent(payload.value.operatorIds)}` : ''}` +
      `${payload.value.idBranch ? `&idBranch=${encodeURIComponent(payload.value.idBranch)}` : ''}` +
      `${payload.value.state ? `&state=${encodeURIComponent(payload.value.state)}` : ''}`;

    const headers = {
      method: 'GET',
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
      }),
    };

    const response = yield call(request, requestURL, headers);

    yield put({ type: 'FETCH_INVEST_DATA_SUCCESS', value: response });
  } catch (error) {
    yield put({
      type: 'SHOW_ALERT',
      value: {
        type: 'danger',
        title: 'Failed to load',
        message: 'Failed to load invest data',
      },
    });
    yield put({ type: 'FETCH_INVEST_DATA_ERROR' });
  } finally {
    yield put({ type: 'HIDE_LOADING' });
  }
}

export function* fetchInvestDataToDownload(payload) {
  try {
    yield put({
      type: "FETCH_INVEST_DATA_TO_DOWNLOAD_REQUEST",
    });
    
    yield put({ type: 'SHOW_LOADING' });

    const params = new URLSearchParams();
    const value = payload.value;

    if (value.page) params.append('page', value.page);
    if (value.search) params.append('search', value.search);
    if (value.from) params.append('from', value.from);
    if (value.to) params.append('to', value.to);
    if (value.senderIds) params.append('senderIds', value.senderIds);
    if (value.operatorIds) params.append('operatorIds', value.operatorIds);
    if (value.idBranch) params.append('idBranch', value.idBranch);
    if (value.state) params.append('state', value.state);

    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/security/downloadAllAddresses?${params.toString()}`;

    const headers = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
    };

    const response = yield call(fetch, requestURL.trim(), headers);

    const blob = yield call([response, 'blob']);

    var fileName='Reporte_Novedades_' + Date.now() + '.csv';

    const url = window.URL.createObjectURL(blob);
    let a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();

    yield put({
      type: "FETCH_INVEST_DATA_TO_DOWNLOAD_SUCCESS",
      payload: { url, fileName }
    });

  } catch (error) {
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "danger",
        title: "Failed download",
        message: "Failed download inventory report",
      },
    });
    yield put({
      type: "FETCH_INVEST_DATA_TO_DOWNLOAD_ERROR",
    });
  } finally {
    yield put({ type: 'HIDE_LOADING' });
  }
}

  
export function* watchFetchInvestData() {
  yield takeLatest('FETCH_INVEST_DATA_REQUESTING', fetchInvestData);
  yield takeLatest('FETCH_INVEST_DATA_TO_DOWNLOAD_REQUESTING', fetchInvestDataToDownload);
}

export default watchFetchInvestData;
